export default __webpack_public_path__ + "static/media/animal-16.f1d1c8e7.svg";